import Image from "next/image";
import { Check } from "lucide-react";

const MSUAdvantages = ({ data }) => {
  const msuAdvantages = data.msuAdvantages
  return (
    <section className="bg-white">
      <div className="max-w-(--max-page-width) mx-auto px-(--container-padding) my-10 md:my-16 lg:my-24">

        <div className="w-full md:max-w-3xl">
          <span className="bg-[#FFA2011A]/90 text-[#FFA201] text-[13px] font-normal px-3 py-2 capitalize">
            {msuAdvantages.tag}
          </span>

          <h2 className="text-[20px] md:text-[25px] lg:text-[30px] xl:text-[42px] font-bold mt-4">
            {msuAdvantages.title}
          </h2>

          <p className="text-black mt-4 text-lg">
            {msuAdvantages.description}
          </p>
        </div>

        <div className="grid md:grid-cols-1 lg:grid-cols-3 gap-6 mt-10">
          {msuAdvantages.cards.map((card, index) => (
            <div
              key={index}
              className="bg-[#FFA201] text-black p-6 flex gap-4"
            >
              <span className="text-xl md:text-2xl lg:text-3xl font-semibold">
                {card.number}
              </span>
              <p className="text-lg leading-relaxed">
                {card.text}
              </p>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-1 lg:grid-cols-2 gap-10 mt-6 md:mt-12 items-start">

          <div>
            <h3 className="font-semibold text-lg md:text-xl text-[#0A2240] mb-6">
              {msuAdvantages.pointerTitle}:
            </h3>

            <ul className="space-y-4">
              {msuAdvantages.highlights.map((item, index) => (
                <li
                  key={index}
                  className="flex items-start gap-3 border-b border-b-[#DDE7F7] pb-3"
                >
                  <div className="bg-black rounded-full p-1 mt-1">
                    <Check className="w-4 h-4 text-white" />
                  </div>
                  <span className="text-lg text-gray-700">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative w-full h-75 md:h-150 max-h-150 hidden md:hidden lg:block  overflow-hidden">
            <Image
              src={msuAdvantages.image}
              alt="Optometry"
              fill
              className="object-cover"
              sizes="(max-width: 768px) 100vw, 50vw"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default MSUAdvantages